import Logo from "../ui/logo";

interface NavbarProps {
  subtitle?: string;
}

export default function Navbar({ subtitle }: NavbarProps) {
  return (
    <nav className="flex h-auto items-center gap-1">
      <Logo subtitle={subtitle} />
    </nav>
  );
}
